import { comparisonColumns } from './comparisonColumns'

export default {
  comparisonColumns,
  userPolicies: [],
  jurisdictionId: false,
  policiesIds : false
}